import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface State {
	userRoleFeatures: string[];
}

const initialState: State = {
	userRoleFeatures: [],
};

const usersSlice = createSlice({
	initialState,
	name: 'users',
	reducers: {
		setUserRoleFeatures: (
			state,
			action: PayloadAction<string[]>
		) => {
			if (action.payload) {
				state.userRoleFeatures = action.payload;
			}
		},
		usersReset: () => initialState,
	},
});

export const { setUserRoleFeatures, usersReset } = usersSlice.actions;
export default usersSlice.reducer;